import axios from 'axios';
import api from '..';

export default ({
  agency = '',
  login = '',
  password = '',
  newpassword = '',
} = {}) => new Promise(() => {
  if (!agency) {
    return Promise.reject('Введите id агентства');
  }
  if (!login) {
    return Promise.reject('Введите логин');
  }
  if (!password) {
    return Promise.reject('Введите пароль');
  }
  const response = {
    auth: false,
    message: null,
    office: null,
    change: {
      office: false,
      password: false,
    },
  };
  return api.store
    .del()
    .then(() => axios.post('/tourclient/account/loginajax', {
      partnerId: agency,
      login,
      password,
      ...(newpassword ? { newpassword } : {}),
    }))
    .then(({ data = {} }) => {
      switch (data.Status) {
        case null:
        case 0:
          response.auth = true;
          response.user = {
            value: data.UserData?.MasterAgentUserId,
            label: data.UserData?.FullName || '',
          };
          response.office = {
            value: data.UserData?.DepartmentId || null,
            label: data.UserData?.Department || '',
          };
          if (data.UserData?.NeedSelectDepartment) {
            response.message = 'Необходимо выбрать офис';
            response.change.office = true;
          }
          return response;
        case 2:
          return Promise.reject('Превышено максимальное количество активных подключений');
        case 3:
          return Promise.reject('Неверный логин или пароль');
        case 4:
          return Promise.reject('Агентство не существует');
        case 5:
          return Promise.reject('Вам запрещен вход в систему');
        case 6:
          response.change.password = true;
          response.message = 'Необходимо указать новый пароль';
          return response;
        default:
          return Promise.reject('В данный момент сервис недоступен');
      }
    });
});
